import { SoundUtil } from '@chesscom/web-ui';
import type { ThemeAssets } from 'chessboard/config/theme-assets';
import { getDefaultOptions } from 'chessboard/model/board/get-default-options';
import { Sounds } from 'chessboard/plugins/sounds/config/types';

const { loadSound } = SoundUtil;

/**
 * Generate a URL for the source of our sound
 */
function getLegacyThemeUrl({ theme = 'default', type, format, themePath }): string {
  const rootPath = themePath || getDefaultOptions()?.assetPaths?.soundsTheme;
  return `${rootPath}_${format.toUpperCase()}_/${theme}/${type}.${format}`;
}

/**
 * Return an array of URLs for all different theme sound types.
 */
export function getLegacyThemeUrls(theme, type, themePath): string[] {
  return ['webm', 'ogg', 'mp3', 'wav'].map((format) =>
    getLegacyThemeUrl({ format, theme, type, themePath }),
  );
}

/**
 * Return an array of URLs for all different extra sound types.
 */
export function getExtraSoundUrls(baseURL, type): string[] {
  return ['webm', 'ogg', 'mp3', 'wav'].map((format) => `${baseURL}/${format}/${type}.${format}`);
}

/**
 * sorts the sound asset formats in order from most preferred to least preferred
 */
function orderSoundAssetFormats(asset: ThemeAssets.SoundAsset): string[] {
  const ordererdFormats: ThemeAssets.SoundAssetFileFormat[] = ['webm', 'ogg', 'mp3', 'wav'];

  return ordererdFormats.reduce((acc, format) => {
    if (asset[format]) {
      acc.push(asset[format]!);
    }
    return acc;
  }, [] as string[]);
}

/**
 * builds Sounds.SoundObject from ThemeAssets.SoundAssets
 */
export function buildSoundsFromSoundAssets(
  soundAssets: ThemeAssets.SoundAssets,
): Sounds.SoundObject {
  return {
    [Sounds.BoardSounds.GameStart]: loadSound(orderSoundAssetFormats(soundAssets.gameStart)),
    [Sounds.BoardSounds.GameEnd]: loadSound(orderSoundAssetFormats(soundAssets.gameEnd)),
    [Sounds.BoardSounds.Capture]: loadSound(orderSoundAssetFormats(soundAssets.capture)),
    [Sounds.BoardSounds.Castle]: loadSound(orderSoundAssetFormats(soundAssets.castle)),
    [Sounds.BoardSounds.Premove]: loadSound(orderSoundAssetFormats(soundAssets.premove)),
    [Sounds.BoardSounds.MoveSelf]: loadSound(orderSoundAssetFormats(soundAssets.moveSelf)),
    [Sounds.BoardSounds.MoveCheck]: loadSound(orderSoundAssetFormats(soundAssets.moveCheck)),
    [Sounds.BoardSounds.MoveOpponent]: loadSound(orderSoundAssetFormats(soundAssets.moveOpponent)),
    [Sounds.BoardSounds.Promote]: loadSound(orderSoundAssetFormats(soundAssets.promote)),
    [Sounds.BoardSounds.Notify]: loadSound(orderSoundAssetFormats(soundAssets.notify)),
    [Sounds.BoardSounds.TenSeconds]: loadSound(orderSoundAssetFormats(soundAssets.tenSeconds)),
    [Sounds.BoardSounds.Illegal]: loadSound(orderSoundAssetFormats(soundAssets.illegal)),
  };
}
